import React from "react";
import Layout from "../components/Layout";
import ServiceCards from "../components/servicepage/servicecards";
import HoverCardLayout from "../components/servicegridextand";
import CollageComponent from "../components/collage";
import DisserationHeader from "../components/disserationheader";

import DissertationServices from "../components/disserationservices"; 
import ScrollingText from "../components/lettersslider";
import ServiceComponent from "../components/servicedescrpition";
import ComponentWithCards from "../components/serviceheadings";
import OurService from "../components/servicepage/ourservice";
import ContactForm from "../components/servicecontact";
import useScrollTransition from "../useScrollTransition";

const Disseration = () => {
  useScrollTransition();
  return (
    <Layout>
      <DisserationHeader />
      <ScrollingText />
      <DissertationServices/>
      <ServiceComponent />
      <ComponentWithCards />
      <OurService />
      <ContactForm />
    </Layout>
  );
};

export default Disseration;
